import React, {useEffect, useState} from "react";
import axios from "axios";
import Layout from "app/hoc/Layout";
import DataTables from "./components/CirculationsTables";
import Filter from "./modals/Filter";
import {updateObject} from "../../../helpers/updateObject";
import View from "./modals/View";
import {objectToQueryString} from "../../../helpers";

function Circulations() {
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [sortField, setSortField] = useState("expiredDate");
    const [orderBy, setOrderBy] = useState(false);
    const [groups, setGroups] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [chooseGroupId, setChooseGroupId] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [deleteGroupsIds, setDeleteGroupsIds] = useState([]);
    const [showFilter, setShowFilter] = useState(false);
    const [showView, setShowView] = useState(false);
    const [filterInputs, setFilterInputs] = useState({
        code: "",
        resultedDate: "",
        expiredDate: "",
        status: "",
        productName: "",
        totalAmount: "",
        possibleSeeTotalAmount: "",
    });

    const handleReset = () => {
        setFilterInputs({
            code: "",
            resultedDate: "",
            expiredDate: "",
            status: "",
            productName: "",
            totalAmount: "",
            possibleSeeTotalAmount: "",
        })
    }

    const toggleDrawer = (open) => () => {
        setShowView(open);
    };

    function handleChange() {
        setShowFilter((key) => !key);
    }

    const onGroups = (filter = {}) => {
        setIsLoading(true);

        const {expiredDate, resultedDate} = filter;

        const query = objectToQueryString({
            ...filter,
            ...(expiredDate && {expiredDate: `${expiredDate}`}),
            ...(resultedDate && {resultedDate: `${resultedDate}`})
        });
        axios
            .get(`circulations/filter?${query}`)
            .then(({data: {data, totalCount}}) => {
                setIsLoading(false);
                setGroups(data);
                setTotalCount(totalCount);
                setIsError(false);
            })
            .catch(() => {
                setIsLoading(false);
                setGroups([]);
                setTotalCount(0);
                setIsError(true);
            });
    };

    const onGroupChoose = (id) => {
        return axios.get(`circulations/circulationGames?id=${id}`);
    };

    const filterInputsUpdate = (e) => {
        const updateFiltersInput = updateObject(filterInputs, {
            [e.target.name]: e.target.value,
        });

        setFilterInputs(updateFiltersInput);
        setSkip(0);
    };

    useEffect(() => {
        const getAllTimer = setTimeout(() => {
            onGroups({...filterInputs, skip, take, orderBy, sortField});
        }, 500);

        return () => {
            clearTimeout(getAllTimer);
        };
    }, [filterInputs, skip, take, orderBy, sortField]);

    return (
        <Layout filter show={showFilter} onHide={handleChange}>
            <DataTables
                groups={groups}
                onGroups={onGroups}
                isLoading={isLoading}
                isError={isError}
                setChooseGroupId={setChooseGroupId}
                setOpenView={toggleDrawer(true)}
                setDeleteGroupsIds={setDeleteGroupsIds}
                deleteGroupsIds={deleteGroupsIds}
                sortField={sortField}
                setSortField={setSortField}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
                totalCount={totalCount}
                skip={skip}
                setSkip={setSkip}
                take={take}
                setTake={setTake}
            />
            {showView && (
                <View
                    open={showView}
                    onClose={toggleDrawer(false)}
                    onGroupChoose={onGroupChoose}
                    chooseGroupId={chooseGroupId}
                />
            )}
            <Filter
                show={showFilter}
                onHide={handleChange}
                filterInputsUpdate={filterInputsUpdate}
                filterInputs={filterInputs}
                resetFilter={handleReset}
                setFilterInputs={setFilterInputs}
            />
        </Layout>
    );
}

export default Circulations;
